// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"QiEgh","rc-tabs-tab-active":"JX+-L","input-suffix":"JNRT8","nav-item":"sD8Fp","locationInfo":"OkQJB","locationInfo-title":"_6Ll4A","locationInfo-body":"NM7a4"};